<template>

    <v-card raised height="100"
            @click="businessRulesDialogModel=true"
            :color="active ? 'green darken-3' : ''">

        <v-container fluid class="pt-0 pb-0">
            <v-icon class="infoIcon" small>mdi-information-outline</v-icon>
            <v-row no-gutters>
                <v-col cols="12">
                    <div class="d-flex flex-row pt-3 pb-0">
                        <v-icon class="pr-2" size="30px">mdi-domain</v-icon>
                        <span class="display-1" v-if="active">
                            ENABLED
                        </span>
                        <span class="display-1" v-else>
                            DISABLED
                        </span>
                    </div>
                </v-col>
            </v-row>

            <v-row no-gutters class="mt-3">
                <v-col>
                    Business rules
                </v-col>
            </v-row>

        </v-container>

        <v-dialog width="800" v-model="businessRulesDialogModel" persistent>
            <business-rules-dialog
                :active="active"
                :json-query="jsonQuery"
                :json-filter="jsonFilter"
                @close="businessRulesDialogModel = false"
                @change="businessRulesToggled"
            ></business-rules-dialog>
        </v-dialog>

    </v-card>

</template>

<script>
import BusinessRulesDialog from "./BusinessRulesDialog";

export default {

    components: {
        BusinessRulesDialog
    },

    props: {
        value: {
            required: false,
            default: true,
            type: Boolean
        },
        jsonQuery: {
            required: true,
            type: Object,
        },
        jsonFilter: {
            required: true,
            type: Object
        },
        enabled: {
            required: false,
            default: true,
        }
    },

    mounted() {
        this.active = this.enabled;
    },

    watch: {
        enabled(value) {
            this.active = value;
        }
    },

    data() {
        return {
            businessRulesDialogModel: false,
            showEditButton: false,
            active: true,
        }
    },

    methods: {
        editButtonClicked() {
            this.businessRulesDialogModel = true;
        },

        businessRulesToggled(businessRules) {
            this.active = businessRules;
            this.$emit("change", businessRules);
        }
    },
}
</script>

<style scoped>

.infoIcon {
    position: absolute;
    top: 10px;
    right: 10px;
}

</style>
